import { createTypes, completeTypes, withPostSuccess, withPostFailure } from 'redux-recompose';

import { handleAPIErrors } from '~model/errors';

import PaymentsService from '../../services/Payments/service';

export const actions = createTypes(completeTypes(['REFUND_TRANSACTION'], []), '@@PAYMENTS');

const targets = {
  REFUND_TRANSACTION: 'refundTransaction'
};
const actionCreators = {
  refundTransaction: (payload, onSuccess) => ({
    type: actions.REFUND_TRANSACTION,
    target: targets.REFUND_TRANSACTION,
    payload,
    service: PaymentsService.refundTransaction,
    injections: [
      withPostSuccess(() => {
        if (onSuccess) {
          onSuccess(payload);
        }
      }),
      withPostFailure((_, response) => {
        handleAPIErrors(response);
      })
    ]
  })
};

export default actionCreators;
